import { useCallback } from 'react'

import { ColorList } from 'core-components/library/common'
import { ModalDialog } from 'core-components/library/modalDialog'

import { IColorModalDialogProps } from './models/IColorModalDialogProps'

export const ColorModalDialog = ({ onChange, visible, value, onClose }: IColorModalDialogProps) => {
  const changeColor = useCallback(
    (icon: string) => {
      onChange(icon)
      onClose()
    },
    [onChange, onClose]
  )

  return (
    <ModalDialog
      size={'auto'}
      show={visible}
      onClose={onClose}
      content={ColorList}
      contentProps={{
        value: value || '',
        onChange: changeColor,
      }}
    />
  )
}
